module.exports = __webpack_public_path__ + "static/media/ZON5-NEW.da58008f.apng";